module.exports = __webpack_public_path__ + "img/Material_production_stock.0522a192.svg";